import { AnyAction } from 'redux';

import type { FetchParams, Totals } from './reducer';

export const APPROVE = 'app/PartnerRequests/APPROVE';
export const DENY = 'app/PartnerRequests/DENY';
export const RESPOND_SUCCESS = 'app/PartnerRequests/RESPOND_SUCCESS';
export const RESPOND_FAILED = 'app/PartnerRequests/RESPOND_FAILED';

export const SET_FETCH_PARAMS = 'app/PartnerRequests/SET_FETCH_PARAMS';
export const SET_DISPLAYED_PARTNER_IDS = 'entities/PartnerRequests/SET_DISPLAYED_PARTNER_IDS';
export const SET_TOTALS = 'entities/PartnerRequests/SET_TOTALS';
export const FETCH_SUCCESS = 'app/PartnerRequests/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/PartnerRequests/FETCH_FAILED';

export const CREATE_PARTNER = 'app/PartnerRequests/CREATE_PARTNER';
export const CREATE_PARTNER_SUCCESS = 'app/PartnerRequests/CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAILED = 'app/PartnerRequests/CREATE_PARTNER_FAILED';

export const CLEAR_ERROR = 'app/PartnerRequests/CLEAR_ERROR';

export const ADD_PARTNER_NONPROFIT_FORM_IDENTIFIER =
  'app/containers/PartnerRequests/AddPartnerNonprofitForm';
export const REQUEST_CORPORATE_PARTNERSHIP_FORM_IDENTIFIER =
  'app/containers/PartnerRequests/RequestCorporatePartnershipForm';

export const FORM_IDENTIFIER = 'app/PartnerRequests';

export enum PARTNER_STATUS_DISPLAY_KEYS {
  accepted = 'accepted',
  rejected = 'rejected',
  pending = 'pending',
}

export enum PARTNER_DATE_FIELD {
  accepted = 'modifiedAt',
  rejected = 'modifiedAt',
  pending = 'createdAt',
}

export interface ApproveAction {
  type: typeof APPROVE;
  id: string;
}
export const approveAction = (id: string): ApproveAction => ({
  type: APPROVE,
  id,
});

export interface DenyAction {
  type: typeof DENY;
  id: string;
}
export const denyAction = (id: string): DenyAction => ({
  type: DENY,
  id,
});

export interface RespondSuccess {
  type: typeof RESPOND_SUCCESS;
  id: string;
}
export const respondSuccess = (id: string): RespondSuccess => ({
  type: RESPOND_SUCCESS,
  id,
});
export interface RespondFailed {
  type: typeof RESPOND_FAILED;
  id: string;
}
export const respondFailed = (id: string): RespondFailed => ({
  type: RESPOND_FAILED,
  id,
});

export interface FetchParamsAction {
  type: typeof SET_FETCH_PARAMS;
  params: Partial<FetchParams>;
}
export const setFetchParamsAction = (params: Partial<FetchParams>): FetchParamsAction => ({
  type: SET_FETCH_PARAMS,
  params,
});

export interface SetTotalsAction {
  type: typeof SET_TOTALS;
  totals: Totals;
}
export const setTotalsAction = (totals: Totals): SetTotalsAction => ({
  type: SET_TOTALS,
  totals,
});

export interface SetDisplayedPartnerIdsAction {
  type: typeof SET_DISPLAYED_PARTNER_IDS;
  partnerIds: string[];
}
export const setDisplayedPartnerIdsAction = (
  partnerIds: string[]
): SetDisplayedPartnerIdsAction => ({
  type: SET_DISPLAYED_PARTNER_IDS,
  partnerIds,
});

export interface FetchSuccessAction {
  type: typeof FETCH_SUCCESS;
}
export const fetchSuccessAction = (): FetchSuccessAction => ({
  type: FETCH_SUCCESS,
});

export interface FetchFailedAction {
  type: typeof FETCH_FAILED;
  error: Error;
}
export const fetchFailedAction = (error: Error): FetchFailedAction => ({
  type: FETCH_FAILED,
  error,
});

export interface CreatePartnerAction {
  type: typeof CREATE_PARTNER;
  id: string;
}
export const createPartnerAction = (id: string): AnyAction => ({
  type: CREATE_PARTNER,
  id,
});

export interface CreatePartnerSuccessAction {
  type: typeof CREATE_PARTNER_SUCCESS;
}
export const createPartnerSuccessAction = (): AnyAction => ({
  type: CREATE_PARTNER_SUCCESS,
});

export interface CreatePartnerFailedAction {
  type: typeof CREATE_PARTNER_FAILED;
  error: Error;
}
export const createPartnerFailedAction = (error: any): AnyAction => ({
  type: CREATE_PARTNER_FAILED,
  error,
});

export interface ClearErrorAction {
  type: typeof CLEAR_ERROR;
}
export const clearErrorAction = (): AnyAction => ({
  type: CLEAR_ERROR,
});

export type PartnerRequestsActions =
  | ApproveAction
  | DenyAction
  | RespondSuccess
  | RespondFailed
  | FetchParamsAction
  | SetDisplayedPartnerIdsAction
  | FetchSuccessAction
  | FetchFailedAction
  | CreatePartnerAction
  | CreatePartnerSuccessAction
  | CreatePartnerFailedAction
  | ClearErrorAction;
